import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-keyboard",
  templateUrl: "./med-icon-keyboard.component.html",
})
export class MedIconKeyboardComponent extends SvgMixinComponent {}
